<template>
  <div class="wrap-index-stat-drawer">
   <el-drawer
    title="批量添加指标"
    :visible.sync="visibleIndexDrawer"
    direction="rtl"
    size="50%"
    :with-header="true"
    :before-close="handleClose"
    custom-class="wrap-head-16">
      <div class="">
        <div class="flex add-tip py-2 px-4 text-theme-black-650">
          <div>
            <p>添加说明：</p>
            <p>支持添加多级指标，各级之间用符号“/”分隔；</p>
            <p>添加多个指标时需要换行，每行为 1 个指标。</p>
            <span class="cursor-pointer" @click="addDemo">填充示例</span>
          </div>
        </div>
        <el-form :model="form" class="p-4">
          <el-form-item>
            <el-input
              class="input-textarea"
              v-model="form.indexs"
              type="textarea"
              :placeholder="placeholder"
            />
          </el-form-item>
        </el-form>
        <div class="footer-btns flex justify-end fixed p-4 right-0 bottom-0 box-border">
          <!-- <el-button type="default" @click="handleClose">取消</el-button> -->
          <el-button class="primary-btn-style" type="primary" @click="submitClick">提交</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
const exampleText = '就业机会与稳定性/职工人数/不同产业职工人数/第一产业职工人数\n就业机会与稳定性/职工人数/不同产业职工人数/第二产业职工人数\n就业机会与稳定性/职工人数/不同产业职工人数/第三产业职工人数'
import { generateId } from '@/assets/js/utils'
import { indicatorDimensionCreate } from '@/api/index-statistics'
import { mapGetters } from 'vuex'
export default {
  name: 'AddIndexDrawer',
  props: {
    visibleIndexDrawer: Boolean
  },
  data() {
    return {
      channel: null,
      form: {
        indexs: ''
      },
      placeholder: '示例：\n' + exampleText,
      levelsNum: 0,
      requiredNum: 0,
      groups: []
    }
  },
  computed: {
    ...mapGetters(['indexStatInfo']),
  },
  created() {},
  mounted() {
  },
  watch: {},
  methods: {
    // 添加指标
    addIndexDImension(){
      indicatorDimensionCreate(this.groups).then(res => {
        if(res.data.code == 0 && res.data.data){
          this.$parent.getIndexDimensionList()
        }else{
          this.$message.error(res.data.msg || '添加失败!')
        }
        // 更新表格
        this.$emit('updataCellTable')
      })
    },
    handleClose(){
      this.form.indexs = ''
      this.$emit('update:visibleIndexDrawer',false)
    },
    submitClick(){
      let typeArr = this.form.indexs.split('\n')
      typeArr.forEach((item, index) => {
        if (!item) {
          typeArr.splice(index, 1)
        }
        if (item.replace(/\s/g, '').length == 0) {
          this.$message.warning('分类名字不能为空格')
          throw new Error('分类名字不能为空格')
        }
        const itemArr = item.split('/')
        const emptyArr = ['', ' ']
        if(emptyArr.includes(itemArr[(itemArr.length - 1)])){
          itemArr.pop()
        }
        itemArr.forEach((child,childindex) => {
          if (itemArr.length < 1) {
            this.$message.warning('指标级数至少为一级')
            throw new Error('指标级数至少为一级')
          }else if (emptyArr.includes(child)) {
            this.$message.warning('指标名字不能为空')
            throw new Error('指标名字不能为空')
          }
        })
      })
      this.updateLinkage(typeArr)
      this.$emit('update:visibleIndexDrawer',false)
      this.form.indexs = ''
      this.addIndexDImension()
    },
    addDemo(){
      if (this.form.indexs.trim()) {
          this.$confirm('是否覆盖已有内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.form.indexs = exampleText
          })
        } else {
          this.form.indexs = exampleText
        }
    },
    updateLinkage(texts = []) {
      // 1 检查是否合法
      let maxLen = 0
      texts.forEach(t => {
        let arr = t.split('/')
        if (arr.length > 5) {
          this.$message.warning('最多支持五级')
          throw new Error('最多支持五级')
        }
        maxLen = Math.max(maxLen, arr.length)
      })
      // 2构建新的 groups
      let groups = texts.reduce((results, item) => {
        let t = item.split('/')
        let options = results
        while (t.length) {
          let content = t.shift()
          let o = options.find(r => r.name === content)
          if (o) {
            options = o.children
          } else {
            let item = {
              indicatorStatisticsId: this.indexStatInfo.id,
              name: content,
              children: []
            }
            options.push(item)
            options = item.children
          }
        }
        return results
      }, [])
      // 3 重置
      this.levelsNum = this.requiredNum = 0
      // 4 递归
      this.groups = groups
    },
    recursionUpdate(groups1 = [], groups2 = [], order = 0, levelNumber = 1) {
      const results = []
      for (let i = 0; i < groups1.length; i++) {
        let item = groups1[i]
        let find = groups2.find(i2 => i2.content === item.content)
        let result = {
          content: item.content,
          id: null,
          levelNumber,
          editOrder: order,
          isNextLevel: false,
          nextLevelOptions: null
        }
        let nextLevelOptions = null
        if (find) {
          result.id = find.id
          nextLevelOptions = find.nextLevelOptions
        } else {
          result.id = generateId()
        }
        if (item.children && item.children.length) {
          result.nextLevelOptions = this.recursionUpdate(item.children, nextLevelOptions || [], order + 1, levelNumber + 1)
          result.isNextLevel = true
        }
        results.push(result)
      }
      this.levelsNum = this.requiredNum = Math.max(this.levelsNum, levelNumber)
      return results
    }
  }
}
</script>
<style lang="scss">
.wrap-index-stat-drawer{
  .el-drawer__header{
    padding: 13px 16px;
    height: 22px;
    background: #F5F7FA;
  }
  .el-textarea__inner{
    height: calc(100vh - 233px);
  }
}
.footer-btns{
  width: 50%;
  border-top: 1px solid rgba(0,0,0,0.1);
}
.primary-btn-style{
  width: 88px;
  height: 32px;
  @apply bg-theme;
  border-radius: 2px;
}
</style>
<style lang="scss" scoped>
.add-tip{
  height: 72px;
  background: #EEEEEE;
  font-size: 12px;
  line-height: 18px;
  span{
    color: rgba(39, 117, 232, 1);
  }
}
.input-textarea{
  color: #C4C7CF;
  line-height: 22px;
  font-size: 14px;
}
</style>
